module.exports = __webpack_public_path__ + "static/media/barracuda.c17acdfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/barracuda.png
// module id = 298
// module chunks = 0